import { Button, Grid, Paper, TextField, useMediaQuery } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";

import style from "./MetersPage.module.scss";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import "dayjs/locale/ru";
import dayjs from "dayjs";
import { PickerValue } from "@mui/x-date-pickers/internals";
import imageCompression from "browser-image-compression";
import { enqueueSnackbar } from "notistack";
import { Reading } from "../../../types/Store/MetersStore.types";

function MetersScoreboard({
    changedMetersValue,
    data,
    handleChangeMeters,
    setHasErrors,
}: {
    data: Reading;
    changedMetersValue: any;
    handleChangeMeters: Function;
    setHasErrors: Function;
}) {
    const [currentUses, setCurrentUses] = useState(0);
    const [currentUsesTextValue, setCurrentUsesTextValue] = useState(0);
    const [dateLast, setDateLast] = useState(dayjs());

    const [file, setFile] = useState<File | null>(null);
    const [fileLoading, setFileLoading] = useState(false);

    const [inputError, setInputError] = useState("");

    const isMobile = useMediaQuery("(max-width:700px)");

    useLayoutEffect(() => {
        setHasErrors((prev: any) => ({ ...prev, [data.meter.id]: true }));
    }, []);

    useEffect(() => {
        if (changedMetersValue[data.meter.id]) {
            setCurrentUses(changedMetersValue[data.meter.id].value);
            setCurrentUsesTextValue(changedMetersValue[data.meter.id].value);
            setFile(changedMetersValue[data.meter.id].file);
        }
    }, [changedMetersValue]);

    const handleChangeUses = (e: any) => {
        if (isNaN(Number(e.target.value))) return;
        const num = Number(e.target.value);
        if (num < data.readings[0]?.value) {
            setInputError("Нельзя ввести число меньше текущего показания");
            setHasErrors((prev: any) => ({ ...prev, [data.meter.id]: true }));
        } else {
            setInputError("");
            setHasErrors((prev: any) => ({ ...prev, [data.meter.id]: false }));
        }

        if (e.target.value.length <= 6) {
            setCurrentUsesTextValue(Number(e.target.value));
        } else return;

        handleChangeMeters(data.meter.id, +e.target.value, file);
    };

    const handleChangeDate = (value: PickerValue) => {
        setDateLast(dayjs(value));
    };

    const handleFileInput = async (event: any) => {
        if (event.target.files.length == 1) {
            try {
                setFileLoading(true);
                setHasErrors((prev: any) => ({
                    ...prev,
                    [data.meter.id + "_loading"]: true,
                }));

                console.log(event.target.files[0]);

                const isPDF = event.target.files[0].type.includes("pdf");
                const isImage = event.target.files[0].type.includes("image");

                if (!isPDF && !isImage)
                    return enqueueSnackbar({
                        variant: "error",
                        message: "Файл должен быть PDF или изображением",
                    });

                if (isPDF && event.target.files[0].size > 5000000)
                    return enqueueSnackbar({
                        variant: "error",
                        message: "Файл слишком большой",
                    });

                const compressedFile = isPDF
                    ? event.target.files[0]
                    : await imageCompression(event.target.files[0], {
                          maxSizeMB: 1,
                          useWebWorker: true,
                          maxWidthOrHeight: 1920,
                      });

                handleChangeMeters(
                    data.meter.id,
                    currentUsesTextValue,
                    compressedFile,
                );
            } catch (error: any) {
                enqueueSnackbar({
                    variant: "error",
                    message: error?.message || "Не удалось сжать файл",
                });
            } finally {
                setFileLoading(false);
                setHasErrors((prev: any) => ({
                    ...prev,
                    [data.meter.id + "_loading"]: false,
                }));
            }
        }
    };

    return (
        <Paper className={style.container}>
            <Grid
                sx={{ width: "100%", flex: 1 }}
                container
                spacing={2}
                justifyContent={"space-between"}
                display={"flex"}
            >
                <Grid
                    size={{ xs: 12, md: 12, xl: 3 }}
                    className={style.info__title}
                >
                    <h2>{data.meter.title || "Прибор учёта"}</h2>
                    <p className={style.score__info}>
                        Прибор учёта №{data.meter.serial_number}
                        {/* <Tooltip title="Здесь будет описание">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.3335 3.66671H7.66683V5.00004H6.3335V3.66671ZM6.3335 6.33337H7.66683V10.3334H6.3335V6.33337ZM7.00016 0.333374C3.32016 0.333374 0.333496 3.32004 0.333496 7.00004C0.333496 10.68 3.32016 13.6667 7.00016 13.6667C10.6802 13.6667 13.6668 10.68 13.6668 7.00004C13.6668 3.32004 10.6802 0.333374 7.00016 0.333374ZM7.00016 12.3334C4.06016 12.3334 1.66683 9.94004 1.66683 7.00004C1.66683 4.06004 4.06016 1.66671 7.00016 1.66671C9.94016 1.66671 12.3335 4.06004 12.3335 7.00004C12.3335 9.94004 9.94016 12.3334 7.00016 12.3334Z"
                                    fill="#07003D"
                                    fill-opacity="0.2"
                                />
                            </svg>
                        </Tooltip> */}
                    </p>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 12, xl: 3 }}
                    className={style.last__info}
                >
                    <h2 className={style.secondary}>Предыдущее показание</h2>
                    <div className={style.last__info__data}>
                        <p>
                            <svg
                                width="13"
                                height="14"
                                viewBox="0 0 13 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.74674 7.00004H4.08008V8.33337H2.74674V7.00004ZM12.0801 3.00004V12.3334C12.0801 12.687 11.9396 13.0261 11.6895 13.2762C11.4395 13.5262 11.1003 13.6667 10.7467 13.6667H1.41341C0.673411 13.6667 0.0800781 13.0667 0.0800781 12.3334V3.00004C0.0800781 2.64642 0.220551 2.30728 0.470605 2.05723C0.720651 1.80718 1.05979 1.66671 1.41341 1.66671H2.08008V0.333374H3.41341V1.66671H8.74675V0.333374H10.0801V1.66671H10.7467C11.1003 1.66671 11.4395 1.80718 11.6895 2.05723C11.9396 2.30728 12.0801 2.64642 12.0801 3.00004ZM1.41341 4.33337H10.7467V3.00004H1.41341V4.33337ZM10.7467 12.3334V5.66671H1.41341V12.3334H10.7467ZM8.08008 8.33337V7.00004H9.41341V8.33337H8.08008ZM5.41341 8.33337V7.00004H6.74675V8.33337H5.41341ZM2.74674 9.66671H4.08008V11H2.74674V9.66671ZM8.08008 11V9.66671H9.41341V11H8.08008ZM5.41341 11V9.66671H6.74675V11H5.41341Z"
                                    fill="#07003D"
                                    fill-opacity="0.5"
                                />
                            </svg>
                            {data.readings[0]?.date
                                ? dayjs(data.readings[0].date).format(
                                      "DD MMMM YYYY",
                                  )
                                : "Нет данных"}
                        </p>
                        <p className={style.currentScore}>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.08024 0.333374C6.20476 0.333374 5.33786 0.505814 4.52902 0.840844C3.72018 1.17587 2.98525 1.66694 2.3662 2.28599C1.11595 3.53624 0.413574 5.23193 0.413574 7.00004C0.413574 8.76815 1.11595 10.4638 2.3662 11.7141C2.98525 12.3331 3.72018 12.8242 4.52902 13.1592C5.33786 13.4942 6.20476 13.6667 7.08024 13.6667C8.84835 13.6667 10.544 12.9643 11.7943 11.7141C13.0445 10.4638 13.7469 8.76815 13.7469 7.00004C13.7469 6.12456 13.5745 5.25765 13.2394 4.44882C12.9044 3.63998 12.4133 2.90505 11.7943 2.28599C11.1752 1.66694 10.4403 1.17587 9.6315 0.840844C8.82263 0.505814 7.95572 0.333374 7.08024 0.333374ZM7.08024 1.66671C8.49473 1.66671 9.8513 2.22861 10.8515 3.2288C11.8517 4.229 12.4136 5.58555 12.4136 7.00004C12.4136 8.60004 11.7469 10 10.6136 11C9.6802 10.1333 8.41357 9.66673 7.08024 9.66673C5.74691 9.66673 4.54691 10.1333 3.54691 11C2.41357 10 1.74691 8.60004 1.74691 7.00004C1.74691 5.58555 2.30881 4.229 3.309 3.2288C4.3092 2.22861 5.66575 1.66671 7.08024 1.66671ZM8.41357 2.92671C8.16024 2.93337 7.92024 3.10004 7.81357 3.36004L6.95357 5.51337L6.88691 5.66671C6.41357 5.75337 6.02024 6.06671 5.84024 6.50671C5.56691 7.19337 5.90024 7.96671 6.58691 8.24004C7.27357 8.51337 8.04691 8.18004 8.32024 7.49337C8.49357 7.05337 8.41357 6.54671 8.12691 6.17337L8.19357 6.00004L9.05357 3.86004L9.06024 3.84004C9.1936 3.50004 9.02691 3.11337 8.68691 2.97337C8.60024 2.94004 8.51357 2.92671 8.41357 2.92671ZM5.74691 3.00004C5.5701 3.00004 5.40053 3.07028 5.2755 3.1953C5.15048 3.32033 5.08024 3.4899 5.08024 3.66671C5.08024 3.84352 5.15048 4.01309 5.2755 4.13811C5.40053 4.26314 5.5701 4.33337 5.74691 4.33337C5.92372 4.33337 6.09329 4.26314 6.21831 4.13811C6.34334 4.01309 6.41357 3.84352 6.41357 3.66671C6.41357 3.4899 6.34334 3.32033 6.21831 3.1953C6.09329 3.07028 5.92372 3.00004 5.74691 3.00004ZM3.74691 5.00004C3.5701 5.00004 3.40053 5.07028 3.2755 5.1953C3.15048 5.32033 3.08024 5.4899 3.08024 5.66671C3.08024 5.84352 3.15048 6.01309 3.2755 6.13811C3.40053 6.26314 3.5701 6.33337 3.74691 6.33337C3.92372 6.33337 4.09329 6.26314 4.21831 6.13811C4.34334 6.01309 4.41357 5.84352 4.41357 5.66671C4.41357 5.4899 4.34334 5.32033 4.21831 5.1953C4.09329 5.07028 3.92372 5.00004 3.74691 5.00004ZM10.4136 5.00004C10.2368 5.00004 10.0672 5.07028 9.9422 5.1953C9.8171 5.32033 9.7469 5.4899 9.7469 5.66671C9.7469 5.84352 9.8171 6.01309 9.9422 6.13811C10.0672 6.26314 10.2368 6.33337 10.4136 6.33337C10.5904 6.33337 10.76 6.26314 10.885 6.13811C11.01 6.01309 11.0802 5.84352 11.0802 5.66671C11.0802 5.4899 11.01 5.32033 10.885 5.1953C10.76 5.07028 10.5904 5.00004 10.4136 5.00004Z"
                                    fill="#07003D"
                                    fill-opacity="0.2"
                                />
                            </svg>
                            {data.readings[0]?.value || 0}
                        </p>
                    </div>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 12, xl: 2 }}
                    className={style.last__date}
                    sx={{
                        maxWidth: "100%",
                    }}
                >
                    <h2
                        className={style.secondary}
                        style={{
                            display: "flex",
                            width: "90%",
                        }}
                    >
                        Дата снятия показаний
                    </h2>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="ru"
                    >
                        <DatePicker
                            label=""
                            defaultValue={dateLast}
                            onChange={handleChangeDate}
                            className="mui-datepicker"
                            disableFuture
                            shouldDisableYear={(date) => {
                                // Отключаем все годы кроме текущей
                                return date.year() !== new Date().getFullYear();
                            }}
                            shouldDisableMonth={(date) => {
                                // Отключаем все месяцы кроме текущего
                                return date.month() !== new Date().getMonth();
                            }}
                            sx={{ maxWidth: "100%", width: "100%" }}
                            slotProps={{
                                textField: {
                                    variant: "outlined",
                                    InputProps: {
                                        sx: {
                                            height: 40,
                                            "& .MuiInputBase-input": {
                                                padding: "8px 12px",
                                            },
                                        },
                                        readOnly: true,
                                    },
                                    InputLabelProps: {
                                        sx: {
                                            top: -6,
                                        },
                                    },
                                },
                            }}
                            format="DD MMMM YYYY"
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 12, xl: 2 }}
                    className={style.current__info}
                >
                    <h2 className={style.secondary}>Текущее показание</h2>
                    <TextField
                        InputProps={{
                            sx: {
                                height: 40,
                                "& .MuiInputBase-input": {
                                    padding: "8px 12px", // регулирует внутренний текст
                                },
                            },
                        }}
                        InputLabelProps={{
                            sx: {
                                top: -6, // сдвигаем label, чтобы он выглядел правильно
                            },
                        }}
                        sx={{ width: "100%" }}
                        onChange={handleChangeUses}
                        value={currentUsesTextValue}
                        error={inputError != ""}
                        helperText={inputError}
                    />
                </Grid>
                <Grid
                    size={{ xs: 12, md: 1, xl: 2 }}
                    className={style.use__info}
                >
                    <h2 className={style.secondary}>Потребление</h2>
                    <p
                        style={{
                            textWrap: "nowrap",
                        }}
                    >
                        {currentUses - (data.readings[0]?.value || 0) > 0
                            ? currentUses - (data.readings[0]?.value || 0)
                            : 0}{" "}
                        {data.meter.units}
                    </p>
                </Grid>
                <Grid
                    size={12}
                    sx={{
                        display: "flex",
                        alignItems: isMobile ? "left" : "center",
                        gap: "16px",
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    <Button
                        variant="outlined"
                        component="label"
                        disabled={fileLoading}
                    >
                        Загрузить фото
                        <input
                            accept="image/*,.pdf"
                            style={{
                                clip: "rect(0 0 0 0)",
                                clipPath: "inset(50%)",
                                height: 1,
                                overflow: "hidden",
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                whiteSpace: "nowrap",
                                width: 1,
                            }}
                            type="file"
                            onChange={handleFileInput}
                        />
                    </Button>
                    {file && (
                        <label htmlFor="raised-button-file">
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setFile(null);
                                    handleChangeMeters(
                                        data.meter.id,
                                        currentUsesTextValue,
                                        null,
                                    );
                                }}
                                sx={{
                                    flex: "0 0 auto",
                                }}
                            >
                                Убрать фото
                            </Button>
                        </label>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
}

export default MetersScoreboard;
